import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Subject, Observable, throwError } from 'rxjs';
import {environment} from '../../environments/environment';
import {UserSettings} from '../user.settings';
import {catchError, map} from 'rxjs/operators';
import {AppSettings} from '../app.settings';
import {Analytic} from '../models/analytic';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(private http: HttpClient) { }
  getAuthorization(): Observable<any>{
    return this.http.get<any>(environment.AnUrl + 'api/checkAuthority', {headers: UserSettings.headers()})
      .pipe(map(data => {
          if (data) {
            return data;
          }
        }),
        catchError(
          error => {
            return throwError(error);
          }
        )
      );
  }
  getGames(): Observable<any>{
    return this.http.get(environment.apiUrl + '/games', {headers: UserSettings.headers()});
  }
  getArenas(): Observable<any>{
    return this.http.get(environment.COM_URL + 'api/arenas/getArenasNames', {headers: UserSettings.headers()})
  }

  getEvents(): Observable<any>{
    return this.http.get(environment.apiUrl + '/events', {headers: UserSettings.headers()})
  }
  getTournaments(): Observable<any>{
    return this.http.get(environment.apiUrl + '/getTournamentsName', {headers: UserSettings.headers()})
  }
  getAnalytics(startingDate, endingDate, arena_countries, with_event, game, tournament, type, arena, event){
    let params = new HttpParams();
    if(startingDate!=null){
      params= params.append('from',startingDate)
    }
    if(endingDate!=null){
      params= params.append('to',endingDate)
    }
    if (arena_countries){
      params= params.append('arena_countries',arena_countries)
    }
    if(with_event){
      params= params.append('with_event',with_event)
    }
    if(type!=null){
      params= params.append('type',type)
    }
    if (game!=""){
      params= params.append('game',game)
    }
    if (tournament && tournament!=null){
      params= params.append('tournament', tournament)
    }
    if (arena!=null){
      params= params.append('arena',arena)
    }
    if (event!=null){
      params= params.append('event',event)
    }
    const options = {headers: UserSettings.headers(), params: params}
    return this.http.get<Analytic>(environment.AnUrl + 'api/gbarenaUserStats', options  )
      .pipe(map(data => {
          if (data) {
            return data;
          }
        }),
        catchError(
          error => {
            return throwError(error);
          }
        )
      );

  }
}
